<template>
  <div>
    <div class="search">
      <el-form :inline="true" style="padding-top:0px;margin-top:20px" :model="searchForm" class="searchForm">
        <el-form-item label="消毒方式：">
          <el-input size="medium" v-model="searchForm.MODE" placeholder="请输入消毒方式名称"></el-input>
        </el-form-item>
        <el-row style="padding-top:10px;padding-bottom:10px">
          <el-button size="medium" @click="serch()" type="primary">筛选</el-button>
          <el-button type="text" size="medium" style="color: #409EFF" @click="clearSearch()">重置筛选条件</el-button>
        </el-row>
      </el-form>
    </div>
    <el-row class="middle">
      <!-- <el-button size="medium" @click="batchReport()" type="primary" >批量上报</el-button> -->
      <el-button size="medium" @click="addDish()" type="primary">新增消毒方式</el-button>
    </el-row>
    <el-row style="padding: 15px 20px;background:white;border-radius:3px">

      <el-table stripe border :data="tableData" :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="方式名称" prop="DM_NAME"></el-table-column>
        <el-table-column label="消毒参数" prop="DP_NAME_LIST"></el-table-column>
        <el-table-column label="状态" prop="CAN_USE">
          <template slot-scope="scope">
            <el-tag :type="scope.row.CAN_USE == 0 ? 'danger' : ''" v-text="setPkStatus(scope.row)"></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="PROJECT_NAME">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="clearingCheck(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="updateRecord(scope.row)">编辑</el-button>

            <el-button type="text" size="small" @click="deleteList(scope.row)" v-if="scope.row.CAN_USE == 1">禁用
            </el-button>
            <el-button type="text" size="small" @click="startList(scope.row)" v-else>启用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination style="text-align: right" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </el-row>
    <el-dialog title="新增消毒方式" center :visible.sync="addFormVisible" width="600px">
      <el-form ref="addForm" v-model="addForm" :label-width="'150px'" :inline="true">

        <el-form-item label="消毒方式：">
          <el-input v-model="addForm.DM_NAME" style="width:350px" maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="消毒方式参数：">
          <el-select filterable v-model="addForm.DP_ID_LIST" placeholder="请选择" style="width:350px" clearable multiple
            collapse-tags>
            <el-option v-for="item in DP_ID_LIST" :key="item.value" :label="item.DP_NAME" :value="item.DP_ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取消</el-button>
        <el-button @click="submitContract()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改消毒方式" center :visible.sync="editFormVisible" width="600px">
      <el-form :model="editForm" ref="editForm" :label-width="formLabelWidth">
        <el-form-item label="消毒方式：">
          <el-input v-model="editForm.DM_NAME" style="width:350px" maxlength="40"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdate()">取消</el-button>
        <el-button @click="submitUpdate()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import date from '@/assets/common/date';
import util from '@/assets/common/util';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
      },
      DP_ID_LIST: [],
      addFormVisible: false,
      addForm: {
        SECOND_TYPE: '',
        DP_ID_LIST: [],
      },
      statusList: ['已禁用', '已启用'],
      formLabelWidth: '120px',
      editFormVisible: false,
      editForm: {},
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      total_count: 0,
      loading1: false,
    };
  },
  computed: {
  },
  created() {
    this.queryList();
    // this.queryFirstType()
    this.querySerchFirst();
    // this.queryType()
  },
  methods: {
    clearSearch() {
      this.searchForm = {
        MONTH: date(Date.now(), '%F').slice(0, 7),
      };
    },
    setPkStatus(row) {
      return this.statusList[Number(row.CAN_USE)];
    },
    changeSecondType() {

    },
    clearingCheck(row) {
      this.$router.push({ path: `/clearingCheck/${row.DM_ID}`, params: { DM_ID: row.DM_ID } });
    },
    // ------------------------编辑
    updateRecord(row) {
      this.editFormVisible = true;
      this.editForm = util.deepCopy(row);
    },
    closeUpdate() {
      this.editFormVisible = false;
      this.queryList();
    },
    submitUpdate() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            // TC_ID:sessionStorage.getItem('companyId'),
            SERVICE_ID: '11011',
            OTYPE: 5,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            CLIENT_TYPE: 2,
            DM_NAME: this.editForm.DM_NAME,
            DM_ID: this.editForm.DM_ID,
            CLIENT_ID: sessionStorage.getItem('tcId'),
          };
          http.post(params).then((result) => {
            this.editFormVisible = false;
            this.queryList();
            this.$message.show({
              text: '修改成功',
              type: 'success',
            });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 获取筛选的一级大类
    querySerchFirst() {
      const params = {
        SERVICE_ID: '11011',
        OTYPE: 16,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        CLIENT_TYPE: 2,
        CLIENT_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        this.DP_ID_LIST = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    chanegSerchFistType(e) {
      this.searchForm.SECOND_TYPE = '';
      if (e !== '') {
        this.queryserchSecondType(e);
      } else {
        this.serchSecondTypes = [];
      }
    },
    queryserchSecondType(index) {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 22,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        FIRST_TYPE_ID: index,

      };
      http.post(params).then((result) => {
        this.serchSecondTypes = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    serch() {
      this.currentPage = 1;
      this.queryList();
    },
    queryList() {
      const params = {
        SERVICE_ID: '11011',
        OTYPE: 2,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        CLIENT_TYPE: 2,
        CLIENT_ID: sessionStorage.getItem('tcId'),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.MODE) {
        params.DM_NAME = this.searchForm.MODE;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].DATA_LIST;
          this.total_count = result[0].TOTAL_COUNT;
        } else {
          // this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
          this.total_count = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addDish() {
      this.addFormVisible = true;
    },
    submitContract() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11011',
            OTYPE: 1,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            DM_NAME: this.addForm.DM_NAME,
            CLIENT_TYPE: 2,
            CLIENT_ID: sessionStorage.getItem('tcId'),
            //  DK_TYPE: this.addForm.DK_TYPE
          };
          if (this.addForm.DP_ID_LIST.length !== 0) {
            params.DP_ID_LIST = this.addForm.DP_ID_LIST;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.addForm = {
              DP_ID_LIST: [],
            };
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
    },
    // 删除
    deleteList(row) {
      this.$confirm('您确定禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          TC_ID: sessionStorage.getItem('companyId'),
          SERVICE_ID: '11011',
          OTYPE: 3,
          DM_ID: row.DM_ID,
          DM_NAME: row.DM_NAME,
          USER_ID: sessionStorage.getItem('userId'),
          CLIENT_TYPE: 2,
          CLIENT_ID: sessionStorage.getItem('tcId'),
          SESSION: sessionStorage.getItem('session'),
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '禁用成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 启用
    startList(row) {
      this.$confirm('您确定启用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '11011',
          OTYPE: 4,
          DM_ID: row.DM_ID,
          DM_NAME: row.DM_NAME,
          USER_ID: sessionStorage.getItem('userId'),
          CLIENT_TYPE: 2,
          CLIENT_ID: sessionStorage.getItem('tcId'),
          SESSION: sessionStorage.getItem('session'),
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '启用成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 修改
    handleCheckDetail(row) {
      this.editForm = row;
      this.editFormVisible = true;
    },
    closeEdit() {
      this.editFormVisible = false;
    },
    submitContractEdit() {
      this.editFormVisible = false;
    },

  },
};

</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}

.qualificatLoad {
  font-size: 14px;
  color: #606266;
}

.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding: 0 40px;
  margin: 0 -20px 0 -20px;
}

.search {
  width: 100%;
}

.searchForm {
  background: white;
  border-radius: 3px;
  padding: 0px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/operationCenter/clearing.vue